import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Textarea, Text, Checkbox } from '@chakra-ui/react';
import ManualReviewConfirmationModal from './manualReviewConfirmationModal';
import { getIsEmailSend, getIsManualReviewEmailSendLoading, getIsShowManualReviewConfirmation } from '@/review/components/selector';
import { useDispatch } from 'react-redux';
import { setIsCertificateStatusUpdated, setIsEmailSend, setIsShowManualReviewConfirmation } from '@/review/ducks/slice';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose(): void;
  modalHeader: string;
  isCancelBtnDisable: boolean;
  isConfirmBtnDisable: boolean;
  isConfirmBtnLoading: boolean;
  onClickConfirmBtn(isEmailIgnored: boolean): void;
  fields: { [key: string | number]: any };
  selectedValue: string;
  handleChange(event: any): void;
  handleTextChange(event: any): void;
  hideDropdown: boolean;
  error: string;
  approvalDetails: any
}



function ReviewConfirmationModal({ isOpen, modalHeader, onClose, isCancelBtnDisable, isConfirmBtnDisable, isConfirmBtnLoading, onClickConfirmBtn, fields, selectedValue, handleChange, handleTextChange, hideDropdown, error, approvalDetails, }: ConfirmationModalProps) {
  const [noteValue, setNoteValue] = useState('')
  const getDocumentId = () => {
    if (approvalDetails?.action_performed_by?.toLowerCase() === "email_campaign" || approvalDetails?.action_performed_by?.toLowerCase() === "dealer" || approvalDetails?.action_performed_by?.toLowerCase() === "upload_ui") {
      return approvalDetails?.client_document_id;
    }
    return ''
  }
  const isManualReview = hideDropdown && approvalDetails && approvalDetails?.action_performed_by && approvalDetails?.manual_review_requested_at && getDocumentId() !== '' ? true : false;
  const isManualReviewEmailSendLoading = getIsManualReviewEmailSendLoading();
  const [reason, setReason] = useState('')
  const isEmailSend = getIsEmailSend();
  const isShowManualReviewConfirmation = getIsShowManualReviewConfirmation();

  const dispatch = useDispatch();

  useEffect(() => {
    if(isOpen){
      dispatch(setIsShowManualReviewConfirmation(false))
      dispatch(setIsCertificateStatusUpdated(false));
      dispatch(setIsEmailSend(false))
      setNoteValue('')
      setReason('')
    }
  }, [isOpen])


  useEffect(() => {
    if (isManualReviewEmailSendLoading) {
      dispatch(setIsShowManualReviewConfirmation(false))
    }
  }, [isManualReviewEmailSendLoading])

  const isNotRequired = () => {
    if(reason && reason?.toLowerCase() === 'others' && noteValue === ''){
       return true
    }
    return false
  }

  const onNoteChangeHandler = (event:any) => {
    setNoteValue(event.target.value)
  }

  const onSubmitClickHandler = () => {
    setTimeout(() => {
      if(isEmailSend) { 
        dispatch(setIsShowManualReviewConfirmation(true))
      } else {
        onClickConfirmBtn(false)
        dispatch(setIsEmailSend(false))
      } 
    }, 100);
  }


  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true}>
      <ModalOverlay className='confirmation-modal__overlay' />
      {isShowManualReviewConfirmation ? (
        <ManualReviewConfirmationModal
          isOpen={isShowManualReviewConfirmation}
          onClose={
            () => {
              dispatch(setIsShowManualReviewConfirmation(false))
              dispatch(setIsEmailSend(false))
              setNoteValue('')
              setReason('')
              onClose()
            }
          }
          isCancelBtnDisable={isCancelBtnDisable}
          isConfirmBtnDisable={isConfirmBtnDisable}
          isConfirmBtnLoading={isConfirmBtnLoading}
          onClickConfirmBtn={() => {
            // setIsShowManualReviewConfirmation(false)
            onClickConfirmBtn(false)
          }}
          id={getDocumentId()}
          reason={reason}
          note={noteValue}
        />
      ) : (
        <ModalContent className='confirmation-modal'>
          <ModalHeader className='confirmation-modal__header'>
            {modalHeader}
            <button className='transfer-create-modal__close-btn' onClick={onClose}><img src='/images/ui/close.svg' /></button>
          </ModalHeader>
          <ModalBody className='confirmation-modal__body' padding="40px 38.5px">
            {hideDropdown && <Select
              placeholder='Select reason*'
              my={3}
              onChange={(event) => {
                handleChange(event)
                setReason(event.target.value)
              }
              }
              required
            >
              {
                Object.entries(fields).map(([key, val]) => <option value={val as string} selected={val === selectedValue}>{val as string}</option>)
              }
            </Select>}
            {hideDropdown && (
              <>
                <Textarea
                  placeholder='Note'
                  rows={5}
                  onChange={(event) =>{
                    handleTextChange(event)
                    onNoteChangeHandler(event)
                   }
                  }
                  name='textarea'
                />
                {error && <Text fontSize='xs' color='red'>{error}</Text>}
                {isNotRequired() && <Text fontSize='xs' color='red'>Note is required.</Text>}
              </>
            )}
            {isManualReview && (
            <Checkbox
              sx={{marginTop: '1rem'}}
              isChecked={isEmailSend}
              onChange={(event) => {
                dispatch(setIsEmailSend(event.target.checked))
              }}
            >
              Do you want to send an email to the dealer?
            </Checkbox>
            )}
          </ModalBody>
          <ModalFooter mt={3} className='confirmation-modal__footer'>
            <Button
              className='confirmation-modal__secondary-btn'
              isDisabled={isCancelBtnDisable}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              onClick={() => onSubmitClickHandler()}
              isLoading={isConfirmBtnLoading}
              isDisabled={isConfirmBtnDisable || isNotRequired() }
              className='confirmation-modal__primary-btn'
            >
              Submit
            </Button>
          </ModalFooter>
        </ModalContent>
      )}
    </Modal>
  )
}

export default ReviewConfirmationModal
